import { Box, CardMedia, Dialog, IconButton, Typography } from "@mui/material";
import { userState } from "../../interface/MainInterface";
import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";
import Toast from "../../utils/Toast";
import { HttpUnAuthApi } from "../../interface/unauth-api";
import { useNavigate } from "react-router-dom";

interface propsType {
//   userState: userState;
  // selectedKeywords: any;
  callback: any;
}

const unAuthAPI = new HttpUnAuthApi();

const PopAddKeyword = (props: propsType, ref: any) => {
  const toastRef: any = useRef();
  const [isLoading, setIsLoading] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [categories, setCategories] = useState<any>([]);
  const [showCategory, setShowCategory] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<any>(null);

  // 키워드 생성 입력란
  const [keywordNameKr, setKeywordNameKr] = useState("");
  const [keywordNameEn, setKeywordNameEn] = useState("");

  useEffect(() => {
    get_category_list();
  }, []);

  const open = useCallback((list: any) => {
    // get_scrap_list();
    setOpenModal(true);
    setShowCategory(false);
    setKeywordNameEn("");
    setKeywordNameKr("");
    setSelectedCategory(null);
  }, []);

  const close = () => {
    props.callback({ command: "close" });
    setOpenModal(false);
    setShowCategory(false);
    setKeywordNameEn("");
    setKeywordNameKr("");
    setSelectedCategory(null);
  };

  const get_category_list = async () => {
    const param: any = {
      command: "get_category_list",
      pk: "trendreport#category",
      sk: "all",
    };
    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
      setCategories(res.response.category_list);
    } else {
      console.error("[ERROR] get_category_list : ", res.response.error_msg);
    }
  };

  const update_category_info = async () => {
    if (keywordNameKr === "" || keywordNameKr === undefined) {
        toastRef.current?.toast("키워드(한글)을 입력하세요.", "error", 4000, { vertical: "top", horizontal: "center" });
        return;
    }
    if (keywordNameEn === "" || keywordNameEn === undefined) {
        toastRef.current?.toast("키워드(영문)을 입력하세요.", "error", 4000, { vertical: "top", horizontal: "center" });
        return;
    }
    if (!window.confirm("키워드를 생성하시겠습니까?")) return;

    setIsLoading(true);
    const param: any = {
        command: "update_category_info",
        category: selectedCategory ? selectedCategory : "all",
        keyword: {
            name_kr: keywordNameKr,
            name_en: keywordNameEn.toUpperCase(),
        },
    }

    const res = await unAuthAPI.post(param);
    if (res.code === "200") {
        window.location.reload();
    } else {
        console.error(res.response.error_msg);
        toastRef.current?.toast("" + res.response.error_msg, "error", 4000, {
            vertical: "top",
            horizontal: "center",
        });
    }
    setIsLoading(false);
    setKeywordNameKr("");
    setKeywordNameEn("");
  };

  const selectCategory = (category: any) => {
    setShowCategory(false);
    setSelectedCategory(category);
  }

  // 부모 Component에서 접근 가능하도록 함수 전달.
  useImperativeHandle(ref, () => ({
    open,
  }));

  return (
    <>
      <Dialog
        open={openModal}
        // onClose={close}
        PaperProps={{
          style: {
            width: "100%",
            maxWidth: "500px",
            background: "#ffffff",
            borderRadius: "30px",
          },
        }}
      >
        <Box className="scrap-modal">
          <Box className="header">
            <Box className="title">
              <Typography className="text">{"키워드 추가"}</Typography>
            </Box>
            <Box className="btn">
              <IconButton
                onClick={() => {
                  close();
                }}
              >
                <CardMedia component={"img"} image="/images/icon-close-m-blk.png" sx={{ height: "22px" }} />
              </IconButton>
            </Box>
          </Box>
          <Box className="title-margin"></Box>
          <div className="category-list-wrap" style={{ padding: "0px 16px 16px 16px"}}>
            <div className="option-wrap" style={{ flexDirection: "column" }}>
              <div className="category" style={{ width: "100%" }}>
                <div className={showCategory ? "category_select_wrap active" : "category_select_wrap"} >
                  <ul className="default_option" style={{ width: "100%" }}>
                    <li
                      onClick={() => {
                        setShowCategory(!showCategory);
                      }}
                    >
                      {selectedCategory === null ? "전체" : selectedCategory.value}
                    </li>
                  </ul>
                  <ul className="select_ul" style={{ width: "100%", maxHeight: "200px" }}>
                    <li
                        onClick={() => {
                            selectCategory(null);
                        }}
                    >
                        전체
                    </li>
                    {categories.map((category: any, index: number) => (
                      <li
                        key={`category-${index}`}
                        onClick={() => {
                          selectCategory(category);
                        }}
                      >
                        {category.value}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div style={{ height: showCategory ? "250px" : "50px" }} />
              <div style={{ display: "flex", flexDirection: "column", gap: "16px", width: "100%" }}>
                <div className="keyword" style={{ width: "100%" }}>
                    <input
                        style={{ width: "100%" }}
                        type="text"
                        placeholder="키워드 (한글)"
                        value={keywordNameKr}
                        onChange={(e) => {
                            setKeywordNameKr(e.target.value);
                        }}
                    />
                </div>
                <div className="keyword" style={{ width: "100%" }}>
                    <input
                        style={{ width: "100%" }}
                        type="text"
                        placeholder="키워드 (영문)"
                        value={keywordNameEn}
                        onChange={(e) => {
                            setKeywordNameEn(e.target.value);
                        }}
                    />
                </div>
              </div>
            </div>
          </div>
          <Box sx={{ display: "flex", justifyContent: "center", p: "24px" }}>
            <Box
              sx={{ display: "flex", justifyContent: "center", width: "100%" }}
              className={keywordNameKr && keywordNameEn ? "btn-add-scrap add-scrap-able" : "btn-add-scrap"}
            >
              <button
                style={{ width: "100%" }}
                onClick={() => {
                    update_category_info();
                }}
              >
                <i>
                  <span>추가하기</span>
                </i>
              </button>
            </Box>
          </Box>
        </Box>
      </Dialog>
      <Toast ref={toastRef} />     
    </>
  )
}

export default forwardRef(PopAddKeyword);